import types from "./types";

const INITIAL_STATE = {
  isFetchingAwv: false,
  isAcoMember: false,
  selectedProviderKeyId: "",
  isFetchingAcoMetrics: false,
  isUpdatingAcoMetrics: false,
  isRefreshingMemberAwvStatus: false,
  isDownloadingMemberPafs: false,
  isDownloadingMemberStatusExcel: false,
};

const hmoReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case types.GET_ACO_AWV_REQUEST:
      return {
        ...state,
        isFetchingAwv: true,
        selectedProviderKeyId: action.payload,
      };

    case types.GET_ACO_AWV_SUCCESS:
      return {
        ...state,
        isFetchingAwv: false,
        isAcoMember: action.payload.length !== 0,
      };

    case types.GET_ACO_AWV_FAILURE:
      return {
        ...state,
        isFetchingAwv: false,
      };

    case types.GET_ACO_METRICS_REQUEST:
      return {
        ...state,
        isFetchingAcoMetrics: true,
        selectedProviderKeyId: action.payload,
      };

    case types.GET_ACO_METRICS_SUCCESS:
      return {
        ...state,
        isFetchingAcoMetrics: false,
        isAcoMember: action.payload.length !== 0,
      };

    case types.GET_ACO_METRICS_FAILURE:
      return {
        ...state,
        isFetchingAcoMetrics: false,
      };

    case types.UPDATE_ACO_METRICS_REQUEST:
      return {
        ...state,
        isUpdatingAcoMetrics: true,
      };

    case types.UPDATE_ACO_METRICS_SUCCESS:
      return {
        ...state,
        isUpdatingAcoMetrics: false,
      };

    case types.UPDATE_ACO_METRICS_FAILURE:
      return {
        ...state,
        isUpdatingAcoMetrics: false,
      };

    case types.REFRESH_MEMBER_AWV_STATUS_REQUEST:
      return {
        ...state,
        isRefreshingMemberAwvStatus: true,
      };

    case types.REFRESH_MEMBER_AWV_STATUS_SUCCESS:
      return {
        ...state,
        isRefreshingMemberAwvStatus: false,
      };

    case types.REFRESH_MEMBER_AWV_STATUS_FAILURE:
      return {
        ...state,
        isRefreshingMemberAwvStatus: false,
      };

    case types.DOWNLOAD_MEMBER_PAFS_REQUEST:
      return {
        ...state,
        isDownloadingMemberPafs: true,
      };

    case types.DOWNLOAD_MEMBER_PAFS_SUCCESS:
      return {
        ...state,
        isDownloadingMemberPafs: false,
      };

    case types.DOWNLOAD_MEMBER_PAFS_FAILURE:
      return {
        ...state,
        isDownloadingMemberPafs: false,
      };

    case types.MEMBER_STATUS_EXCEL_REQUEST:
      return {
        ...state,
        isDownloadingMemberStatusExcel: true,
      };

    case types.MEMBER_STATUS_EXCEL_SUCCESS:
      return {
        ...state,
        isDownloadingMemberStatusExcel: false,
      };

    case types.MEMBER_STATUS_EXCEL_FAILURE:
      return {
        ...state,
        isDownloadingMemberStatusExcel: false,
      };

    default:
      return state;
  }
};

export default hmoReducer;
